export default __webpack_public_path__ + "static/media/android_3.aac768de.jpg";